module.exports = __webpack_public_path__ + "static/img/ppweb_mockup.e0c5b34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ppweb_mockup.png
// module id = NZ5c
// module chunks = 0